<app-date-picker
  (selectedDate)="onDateSelected($event)"
  [maxDate]="input.serviceEndDate"
  [minDate]="input.serviceStartDate"
  [label]="input.label | translate"
></app-date-picker>
